import state from "./moduleTypeConfigCrudState.js";
import mutations from "./moduleTypeConfigCrudMutations.js";
import actions from "./moduleTypeConfigCrudActions.js";
import getters from "./moduleTypeConfigCrudGetters.js";

export default {
	isRegistered: false,
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
};
